import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 21h10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19.5 12 22 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Soup";
const Soup = memo(themed(Icon));
export {
  Soup
};
//# sourceMappingURL=soup.js.map
